/* ============================================================
   SOLENNE — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ---- Header scroll behaviour -------------------------------- */
  const header = document.querySelector('.site-header');

  function onScroll() {
    if (!header) return;
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- Mobile menu -------------------------------------------- */
  const hamburger   = document.querySelector('.site-header__hamburger');
  const mobileMenu  = document.querySelector('.mobile-menu');
  const menuClose   = document.querySelector('.mobile-menu__close');
  const overlay     = document.querySelector('.sol-overlay');
  const desktopMenuQuery = window.matchMedia('(min-width: 1025px)');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-active');
    if (hamburger) {
      hamburger.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-active');
    if (hamburger) {
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  function unlockDesktopScroll() {
    if (desktopMenuQuery.matches) closeMenu();
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (overlay)   overlay.addEventListener('click', closeMenu);
  if (desktopMenuQuery.addEventListener) {
    desktopMenuQuery.addEventListener('change', unlockDesktopScroll);
  } else if (desktopMenuQuery.addListener) {
    desktopMenuQuery.addListener(unlockDesktopScroll);
  }
  window.addEventListener('pageshow', unlockDesktopScroll);
  unlockDesktopScroll();

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* ---- Scroll reveal (Intersection Observer) ------------------ */
  const revealElements = document.querySelectorAll('.reveal');

  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealElements.forEach(function (el) { io.observe(el); });
  } else {
    revealElements.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Smooth scroll for anchor links ------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        closeMenu();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Product form: variant selection ------------------------ */
  const variantSelect = document.querySelector('.product-variant-select');
  const priceEl       = document.querySelector('.product-hero__price');

  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const price = selectedOption.dataset.price;
      if (price) priceEl.textContent = price;
    });
  }

  /* ---- Quote form: show/hide on CTA click -------------------- */
  document.querySelectorAll('[data-open-quote]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = document.querySelector('#quote-form-section');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstInput = target.querySelector('input, textarea');
        if (firstInput) setTimeout(function () { firstInput.focus(); }, 600);
      }
    });
  });

  /* ---- Specialist link scroll -------------------------------- */
  document.querySelectorAll('[data-open-specialist]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = document.querySelector('#quote-form-section');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const textarea = target.querySelector('textarea');
        if (textarea) {
          setTimeout(function () {
            textarea.focus();
            if (!textarea.value) {
              textarea.value = 'I would like to speak with a SOLENNE specialist about the WT-10 Cold Immersion System.';
            }
          }, 600);
        }
      }
    });
  });

  /* ---- No-JS class removal ----------------------------------- */
  document.documentElement.classList.remove('no-js');

})();

/* ============================================================
   PRODUCT PAGE ENHANCEMENTS
   ============================================================ */

(function () {
  'use strict';

  /* ---- Accordions ----------------------------------------- */
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    var trigger = accordion.querySelector('.accordion__trigger');
    var body    = accordion.querySelector('.accordion__body');
    if (!trigger || !body) return;

    trigger.addEventListener('click', function () {
      var isOpen = accordion.classList.contains('is-open');

      document.querySelectorAll('[data-accordion].is-open').forEach(function (other) {
        if (other === accordion) return;
        var otherBody = other.querySelector('.accordion__body');
        other.classList.remove('is-open');
        other.querySelector('.accordion__trigger').setAttribute('aria-expanded', 'false');
        otherBody.hidden = true;
      });

      if (isOpen) {
        accordion.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        body.hidden = true;
      } else {
        accordion.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        body.hidden = false;
      }
    });
  });

  /* ---- Buy Now: items-array AJAX → custom checkout ------- */
  var buyNowForm = document.getElementById('product-hero-form');
  if (buyNowForm) {
    buyNowForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = buyNowForm.querySelector('button[type="submit"]');
      var originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding&hellip;'; }

      var variantInput = buyNowForm.querySelector('input[name="id"]');
      var variantId    = variantInput ? parseInt(variantInput.value, 10) : null;

      if (!variantId) {
        if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
        buyNowForm.submit();
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (res) {
        if (res.ok) {
          window.location.href = '/pages/review-your-order';
        } else {
          return res.json().then(function (data) {
            if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
            var msg = (data.items && data.items[0] && data.items[0].message) ||
                      data.description || 'Unable to add to cart. Please try again.';
            alert(msg);
          });
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
        buyNowForm.submit();
      });
    });
  }

  /* ---- Sticky bar ----------------------------------------- */
  var stickyBar   = document.getElementById('product-sticky-bar');
  var heroSection = document.getElementById('product-hero-section');

  if (stickyBar && heroSection) {
    var heroObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      },
      { threshold: 0.1 }
    );
    heroObserver.observe(heroSection);
  }

})();
